/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
 * Generated from ../../api/openapi.json
 * Generated by generate-api-guards.ts
 * To regenerate, run the following command in the frontend folder:
 *    pnpm run generate:integration
 * Contact the Core Team if any issues arise.
 */

import { isSomeEntity } from './api-guards-utils'
import { components } from './api-types.generated'

export function isAgeGroupOut(entity: unknown): entity is components['schemas']['AgeGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'age_group'
}

export function isBackfillQueueOut(entity: unknown): entity is components['schemas']['BackfillQueueOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'backfill_queue'
}

export function isBackfillQueueOutPopulated(entity: unknown): entity is components['schemas']['BackfillQueueOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'backfill_queue'
}

export function isBlockScheduleOut(entity: unknown): entity is components['schemas']['BlockScheduleOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'block_schedule'
}

export function isBlockScheduleOutPopulated(entity: unknown): entity is components['schemas']['BlockScheduleOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'block_schedule'
}

export function isChecklistItemDefinitionOut(entity: unknown): entity is components['schemas']['ChecklistItemDefinitionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'checklist_item_definition'
}

export function isCommentOut(entity: unknown): entity is components['schemas']['CommentOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'comment'
}

export function isCommentOutPopulated(entity: unknown): entity is components['schemas']['CommentOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'comment'
}

export function isCommentsMessageOut(entity: unknown): entity is components['schemas']['CommentsMessageOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'comments_message'
}

export function isCommentsMessageReactionOut(entity: unknown): entity is components['schemas']['CommentsMessageReactionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'comments_message_reaction'
}

export function isCommentsThreadOut(entity: unknown): entity is components['schemas']['CommentsThreadOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'comments_thread'
}

export function isCommentsThreadReactionOut(entity: unknown): entity is components['schemas']['CommentsThreadReactionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'comments_thread_reaction'
}

export function isDepartmentLocationAssignmentOut(entity: unknown): entity is components['schemas']['DepartmentLocationAssignmentOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'department_location_assignment'
}

export function isDepartmentOut(entity: unknown): entity is components['schemas']['DepartmentOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'department'
}

export function isDepartmentOutPopulated(entity: unknown): entity is components['schemas']['DepartmentOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'department'
}

export function isDepartmentPractitionerAssignmentOut(entity: unknown): entity is components['schemas']['DepartmentPractitionerAssignmentOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'department_practitioner_assignment'
}

export function isHospitalSurgeryTypeGroupAssociationOut(entity: unknown): entity is components['schemas']['HospitalSurgeryTypeGroupAssociationOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'hospital_surgery_type_group_association'
}

export function isHospitalSurgeryTypeOut(entity: unknown): entity is components['schemas']['HospitalSurgeryTypeOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'hospital_surgery_type'
}

export function isInboxEntryOut(entity: unknown): entity is components['schemas']['InboxEntryOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'inbox_entry'
}

export function isLocationOut(entity: unknown): entity is components['schemas']['LocationOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location'
}

export function isLocationOutPopulated(entity: unknown): entity is components['schemas']['LocationOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'location'
}

export function isLocationPostOpAssociationOut(entity: unknown): entity is components['schemas']['LocationPostOpAssociationOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_post_op_association'
}

export function isLocationProfileOut(entity: unknown): entity is components['schemas']['LocationProfileOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_profile'
}

export function isLocationProfileOutPopulated(entity: unknown): entity is components['schemas']['LocationProfileOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_profile'
}

export function isLocationProfileSurgeryTypeGroupOut(entity: unknown): entity is components['schemas']['LocationProfileSurgeryTypeGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_profile_surgery_type_group'
}

export function isLocationScheduleActivityLogOut(entity: unknown): entity is components['schemas']['LocationScheduleActivityLogOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_schedule_activity_log'
}

export function isLocationScheduleOut(entity: unknown): entity is components['schemas']['LocationScheduleOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_schedule'
}

export function isLocationScheduleOutPopulated(entity: unknown): entity is components['schemas']['LocationScheduleOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_schedule'
}

export function isLocationScheduleSpecialityActivityLogOut(entity: unknown): entity is components['schemas']['LocationScheduleSpecialityActivityLogOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_schedule_speciality_activity_log'
}

export function isLocationScheduleSpecialityOut(entity: unknown): entity is components['schemas']['LocationScheduleSpecialityOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_schedule_speciality'
}

export function isLocationScheduleSpecialityOutPopulated(entity: unknown): entity is components['schemas']['LocationScheduleSpecialityOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_schedule_speciality'
}

export function isLocationServiceOverrideOut(entity: unknown): entity is components['schemas']['LocationServiceOverrideOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'location_service_override'
}

export function isMailingListOut(entity: unknown): entity is components['schemas']['MailingListOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'email'
}

export function isPlanningDomainOut(entity: unknown): entity is components['schemas']['PlanningDomainOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'planning_domain'
}

export function isPlanningNoteHistoryRecordOut(entity: unknown): entity is components['schemas']['PlanningNoteHistoryRecordOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'planning_note_history_record'
}

export function isPlanningNoteMigrationRecordOut(entity: unknown): entity is components['schemas']['PlanningNoteMigrationRecordOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'planning_note_migration_record'
}

export function isPlanningPeriodOut(entity: unknown): entity is components['schemas']['PlanningPeriodOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'planning_period'
}

export function isPlanningPeriodOutPopulated(entity: unknown): entity is components['schemas']['PlanningPeriodOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'planning_period'
}

export function isPostOpCapacityOverrideOut(entity: unknown): entity is components['schemas']['PostOpCapacityOverrideOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'post_op_capacity_override'
}

export function isPostOpCapacityPeriodOut(entity: unknown): entity is components['schemas']['PostOpCapacityPeriodOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'post_op_capacity_period'
}

export function isPostOpOut(entity: unknown): entity is components['schemas']['PostOpOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'post_op'
}

export function isPostOpOutPopulated(entity: unknown): entity is components['schemas']['PostOpOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'post_op'
}

export function isPractitionerOut(entity: unknown): entity is components['schemas']['PractitionerOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner'
}

export function isPractitionerOutPopulated(entity: unknown): entity is components['schemas']['PractitionerOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner'
}

export function isPractitionerProfileOut(entity: unknown): entity is components['schemas']['PractitionerProfileOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_profile'
}

export function isPractitionerProfileOutPopulated(entity: unknown): entity is components['schemas']['PractitionerProfileOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_profile'
}

export function isPractitionerProfileSurgeryTypeGroupOut(entity: unknown): entity is components['schemas']['PractitionerProfileSurgeryTypeGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_profile_surgery_type_group'
}

export function isPractitionerScheduleActivityLogOut(entity: unknown): entity is components['schemas']['PractitionerScheduleActivityLogOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_activity_log'
}

export function isPractitionerScheduleLocationActivityLogOut(entity: unknown): entity is components['schemas']['PractitionerScheduleLocationActivityLogOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_location_activity_log'
}

export function isPractitionerScheduleLocationOut(entity: unknown): entity is components['schemas']['PractitionerScheduleLocationOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_location'
}

export function isPractitionerScheduleLocationOutPopulated(entity: unknown): entity is components['schemas']['PractitionerScheduleLocationOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_location'
}

export function isPractitionerScheduleOut(entity: unknown): entity is components['schemas']['PractitionerScheduleOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule'
}

export function isPractitionerScheduleOutPopulated(entity: unknown): entity is components['schemas']['PractitionerScheduleOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule'
}

export function isPractitionerScheduleStatusActivityLogOut(entity: unknown): entity is components['schemas']['PractitionerScheduleStatusActivityLogOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_status_activity_log'
}

export function isPractitionerScheduleStatusOut(entity: unknown): entity is components['schemas']['PractitionerScheduleStatusOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_status'
}

export function isPractitionerScheduleStatusOutPopulated(entity: unknown): entity is components['schemas']['PractitionerScheduleStatusOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_schedule_status'
}

export function isPractitionerServicePeriodOut(entity: unknown): entity is components['schemas']['PractitionerServicePeriodOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_service_period'
}

export function isPractitionerStatusDefinitionOut(entity: unknown): entity is components['schemas']['PractitionerStatusDefinitionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'practitioner_status_definition'
}

export function isPrioritizedPatientGroupOut(entity: unknown): entity is components['schemas']['PrioritizedPatientGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'prioritized_patient_group'
}

export function isPrioritizedPatientGroupOutPopulated(entity: unknown): entity is components['schemas']['PrioritizedPatientGroupOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'prioritized_patient_group'
}

export function isRecurringAssignmentOut(entity: unknown): entity is components['schemas']['RecurringAssignmentOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'recurring_assignment'
}

export function isRecurringAssignmentOutPopulated(entity: unknown): entity is components['schemas']['RecurringAssignmentOutPopulated'] {
    return isSomeEntity(entity) && entity.entity_type === 'recurring_assignment'
}

export function isSectionOut(entity: unknown): entity is components['schemas']['SectionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'section'
}

export function isSpecialityOut(entity: unknown): entity is components['schemas']['SpecialityOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'speciality'
}

export function isStaffingPlanExecutionOut(entity: unknown): entity is components['schemas']['StaffingPlanExecutionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'staffing_plan_execution'
}

export function isStaffingSurgeryGroupOut(entity: unknown): entity is components['schemas']['StaffingSurgeryGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'staffing_surgery_group'
}

export function isStaffingSurgeryGroupSurgeryTypeGroupOut(entity: unknown): entity is components['schemas']['StaffingSurgeryGroupSurgeryTypeGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'staffing_surgery_group_surgery_type_group'
}

export function isStatusDefinitionDepartmentAssignmentOut(entity: unknown): entity is components['schemas']['StatusDefinitionDepartmentAssignmentOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'status_definition_department_assignment'
}

export function isSurgeryFolderMetadatumOut(entity: unknown): entity is components['schemas']['SurgeryFolderMetadatumOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'surgery_folder_metadatum'
}

export function isSurgeryMetadataSuggestionOut(entity: unknown): entity is components['schemas']['SurgeryMetadataSuggestionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'surgery_metadata_suggestion'
}

export function isSurgeryTypeGroupAgeRestrictionOut(entity: unknown): entity is components['schemas']['SurgeryTypeGroupAgeRestrictionOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'surgery_type_group_age_restriction'
}

export function isSurgeryTypeGroupHierarchyOut(entity: unknown): entity is components['schemas']['SurgeryTypeGroupHierarchyOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'surgery_type_group_hierarchy'
}

export function isSurgeryTypeGroupOut(entity: unknown): entity is components['schemas']['SurgeryTypeGroupOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'surgery_type_group'
}

export function isSurgeryTypeGroupSpecialityOut(entity: unknown): entity is components['schemas']['SurgeryTypeGroupSpecialityOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'surgery_type_group_speciality'
}

export function isTacticalPlanSnapshotOut(entity: unknown): entity is components['schemas']['TacticalPlanSnapshotOut'] {
    return isSomeEntity(entity) && entity.entity_type === 'tactical_plan_snapshot'
}
